<template>
  <!-- <Hero :autocompleted-addresses="autocompletedAddresses" :address="address" @onAutocompletedAddressClicked="handleAutocompletedAddressClicked" @onCheckAddressClicked="handleCheckAddressClicked" @onAddressSearchInputted="handleAddressSearchInputted"/> -->
  <Hero v-if="brandService.getName() === Brand.HIS" :autocompleted-addresses="autocompletedAddresses" :address="address" @onAutocompletedAddressClicked="handleAutocompletedAddressClicked" @onCheckAddressClicked="handleCheckAddressClicked" @onAddressSearchInputted="handleAddressSearchInputted"/>

  <Hero1 v-if="brandService.getName() === Brand.NEX" :autocompleted-addresses="autocompletedAddresses" :address="address" @onAutocompletedAddressClicked="handleAutocompletedAddressClicked" @onCheckAddressClicked="handleCheckAddressClicked" @onAddressSearchInputted="handleAddressSearchInputted"/>
  <Features v-if="brandService.getName() !== Brand.HIS" class="pt-28" :features="featuresData.features" :header="featuresData.header" id="features"/>
  <div v-if="brandService.getName() === Brand.NEX" class="bg-landing-plans pt-10 md:pt-20 relative overflow-hidden">
    <!-- <img src="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/ribbon-bg.png" alt=""
      style="top: 50%; left: 50%; transform: translate(-50%, -50%);" class="absolute inset-0 z-0 object-cover object-center w-full" /> -->
    <div class="max-w-7xl mx-auto relative z-20 md:px-0 px-6" id="plans">
      <div class="grid grid-cols-1 md:grid-cols-3 z-50">
        <div class="text-left col-start-1 flex flex-col pt-4">
          <p class="text-md text-black font-poppins tracking-widest">CHOOSE YOUR INTERNET PLAN</p>
          <img class="w-1/2 py-2" src="https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/herenowlive.png"/>
          <p class="text-lg text-black font-poppins tracking-normal">Powered by Opticomm</p>
        </div>
        <div class="text-left col-span-2 ">
          <p class="text-md text-black font-poppins tracking-normal max-w-sm pt-6">Browse, stream or game to your heart's content. Our wide range of internet plans have no data caps. You just need to decide how fast you want to go.</p>
        </div>
      </div>
    </div>
    <div class="max-w-7xl mx-auto relative z-20  md:px-0 px-6">
      <PlanSelector2 class="mb-20" :canSelectProduct="false" :products="products" :selected="''" />
    </div>
  </div>
  <div v-if="brandService.getName() === Brand.NEX"  class="bg-img2 relative overflow-hidden"> </div>
  <div class="bg-white pb-20 max-w-7xl mx-auto md:px-8 px-6"  id="contact">
    <HelpOptions2 v-if="brandService.getName() === Brand.NEX" class="pb-20" :features="contacts"/>
    <HispFeatures v-if="brandService.getName() === Brand.HIS" class="pt-20 mb-20" :features="featuresData.features" :header="featuresData.header" id="features"/>
    <div v-if="brandService.getName() === Brand.HIS">
      <hr v-if="brandService.getName() === Brand.HIS"  class="text-brand-primary max-w-4xl text-center border-2 border-brand-primary mx-auto">
      <Title class="mt-20" :title="brandService.getName() !== Brand.HIS ? 'Our plans.' : 'Our Internet Plans'" :centered="true" id="plans"/>
      <p v-show="brandService.getName() === Brand.HIS" class="max-w-prose mx-auto text-xl text-gray-700 font-gotham-bold text-center py-2">
        Powered by Opticomm
      </p>
      <PlanSelector class="mt-12 mb-20" :canSelectProduct="false" :products="products" :selected="''" />

    </div>
    <Title  v-if="brandService.getName() === Brand.HIS" class="mt-20 mb-4" title="How can we help?" :centered="true"/>
    <HelpOptions  v-if="brandService.getName() === Brand.HIS" class="pb-20" :features="contacts" />
  </div>
</template>

<script lang="ts" setup>
import Hero from '../components/content/Hero.vue';
import Hero1 from '../components/content/Hero1.vue';
import Features from '../components/content/Features.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import HelpOptions2 from '../components/content/HelpOptions2.vue';
import PlanSelector from '../components/ordering/PlanSelector.vue';
import PlanSelector2 from '../components/ordering/PlanSelector2.vue';
import Title from '../components/content/Title.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Address, AutocompleteAddressAdapterInterface } from '@/adapters/autocompleteAddressAdapterInterface';
import { Ref, ref } from 'vue';
import { ServiceQualificationAdapterInterface } from '@/adapters/serviceQualificationAdapterInterface';
import store from '@/store';
import router from '@/router';
import { Brand } from '../services/integration/enums';
import { useGtm } from '@gtm-support/vue-gtm';
import HispFeatures from '@/components/content/HispFeatures.vue';

const gtm = useGtm();

const autocompleteAddressAdapter = injectStrict<AutocompleteAddressAdapterInterface>('AutocompleteAddressAdapterInterface');
const serviceQualificationAdapter = injectStrict<ServiceQualificationAdapterInterface>('ServiceQualificationAdapterInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const featuresData = brandService.getFeaturesData();
const contacts = brandService.getContacts();
const products = brandService.getDefaultPlanSelectorProducts();

// Data.
const address = ref('');
const autocompletedAddresses: Ref<Array<Address>> = ref([]);
const selectedAddress: Ref<Address|undefined> = ref();

// Event handlers.
const unitiRedirect = async () => {
  if (brandService.getName() === Brand.JAM) {
    router.push('/uniti');
  }
};

unitiRedirect();
const handleAddressSearchInputted = async (inputAddress: string) => {
  // When the user types into the address search field, fetch addresses from sq.
  address.value = inputAddress;
  const addresses = await autocompleteAddressAdapter.autocompleteAddress(inputAddress);
  autocompletedAddresses.value = addresses;
};

const handleAutocompletedAddressClicked = (autocompletedAddress: Address) => {
  // When a user clicks an address, set it as the address in the input.
  address.value = autocompletedAddress.address;
  selectedAddress.value = autocompletedAddress;
  autocompletedAddresses.value = [];
};

const handleCheckAddressClicked = async (inputAddress: string, done: () => void) => {
  // When the user submits an address.
  if (selectedAddress.value) {
    // Do SQ.
    const serviceQualification = await serviceQualificationAdapter.serviceQualification(selectedAddress.value);

    if (serviceQualification !== null && serviceQualification?.carrier) {
      console.log('yes', serviceQualification);
      // Save SQ to store.
      store.commit('setServiceQualification', serviceQualification);

      if (gtm) {
        gtm.trackEvent({
          event: 'SQ_ADDRESS_CLICKED',
          category: 'SHOPPING',
          action: 'click',
          label: 'SQ ADDRESS SEARCH',
          noninteraction: false,
          state: serviceQualification.state,
          carrier: serviceQualification.carrier
        });
      }

      // Change page.

      if (brandService.getName() === Brand.HIS) {
        router.push('/sign-up-his');
      } else if (brandService.getName() === Brand.NEX) {
        router.push('/sign-up');
      }
    } else {
      console.log('no', serviceQualification);
      if (gtm) {
        gtm.trackEvent({
          event: 'SQ_NOT_SERVICEABLE',
          category: 'SHOPPING',
          action: 'click',
          label: 'SQ NOT SERVICEABLE',
          noninteraction: false
        });
      }
      router.push('/not-serviceable');
    }
  } else {
    done();
  }
};
</script>

<style scoped>
.bg-landing-plans {
  background-color: #D8CEC4;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/ribbon-bg.png");
  background-position: top center;
  background-size: cover;
  height: auto;
}

.bg-img2 {
  background-color: #000;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/nexee-bg2.png");
  background-position: center;
  background-size: cover;
  height: 90vh;
}

@media only screen and (max-width: 768px) {
  .bg-img2 {
    background-color: #000;
    background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/nexee-bg2.png");
    background-position: center;
    background-size: cover;
    height: 30vh;
  }
}
</style>
